import { z, ZodType } from 'zod'

import {
  TravelExpensesComment,
  TravelExpensesCommentInput
} from '../../../lib/types/models/travel-expenses/travel-expenses-comment'
import { createStringSchema } from '../../../lib/utils/validations/string-validation'

export const TRAVEL_EXPENSES_COMMENT_SCHEMA: ZodType<
  Omit<TravelExpensesCommentInput, 'updatedAt'>
> = z.object({
  comment: createStringSchema('Comment')
})

export const mapTravelExpensesCommentToInput = (
  data: TravelExpensesComment
): TravelExpensesCommentInput => {
  return {
    comment: data.comment,
    updatedAt: data.updatedAt
  }
}
